<template>
	<div>
		<div class="road-info" @click="toJump">
			<img class="thumb" :src="imgPath+item.pcImageUrl" alt="">
			<div class="info-box">
				<div class="title-box">
					<span class="title">{{item.roadshowTitle}}</span>
					<div class="tips" v-if="item.status==0">预约中</div>
					<div class="tips-end" v-if="item.status==-1">已结束</div>
					<div class="tips" v-if="item.status==1">进行中</div>
				</div>
				<div class="descs">
					{{item.content||''}}
				</div>
				<div class="time">
					<div class="icon"><img src="@/assets/road_time.png" alt=""></div>
					<div class="time-info">
						<div class='color-999'>直播时间</div>
						<div class="color-1a margin-top-10">{{item.beginTime}} — {{item.endTime}}</div>
					</div>
				</div>
				<div class="company">
					<div class="icon"><img src="@/assets/road_danwei.png" alt=""></div>
					<div class="company-info">
						<div class='color-999'>主办单位</div>
						<div class="color-1a margin-top-10">{{item.organizer}}</div>
					</div>
				</div>
				<div class="anchor">
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:['item'],
		data(){
			return{
				imgPath:"",
			}
		},
		created() {
			this.imgPath = this.$api.baseUrl + this.$api.imgPath;
		},
		methods:{
			toJump(){
				this.$emit("click",this.item.id)
			}
		}
	}
</script>

<style scoped>
	.road-info {
		display: flex;
		margin-top: 33px;
		border: 1px solid #E6E6E6;
		cursor: pointer;
	}
	
	.road-info .thumb {
		width: 642px;
		height: 361px;
		object-fit: cover;
	}
	
	.road-info .info-box {
		padding: 40px;
		width: 486px;
		position: relative;
	}
	
	.road-info .anchor {
		position: absolute;
		bottom: 30px;
		width: 576px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.road-info .info-box .title-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.road-info .info-box .title-box .title {
		font-size: 24px;
		width: 330px;
		font-weight: 500;
		color: #1A1A1A;
	}
	
	.road-info .info-box .title-box .tips {
		width: 60px;
		height: 24px;
		background: #13B8EE;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #13B8EE;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.road-info .info-box .title-box .tips-end {
		width: 60px;
		height: 24px;
		background: #999;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #999;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.road-info .info-box .descs {
		color: #666666;
		margin-top: 24px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.road-info .info-box .time {
		margin-top: 32px;
		display: flex;
		align-items: center;
	}
	
	.road-info .info-box .time .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}
	
	.road-info .info-box .time .time-info {
		margin-left: 10px;
	}
	
	.road-info .info-box .company {
		margin-top: 16px;
		display: flex;
		align-items: center;
	}
	
	.road-info .info-box .company .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}
	
	.road-info .info-box .company .company-info {
		margin-left: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/RoadShow/RoadShowCard.vue